import { inject } from '@angular/core';
import { Router, CanActivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AppConfiguration } from '@/app/conf/app.configuration';
import { AuthService } from '@/app/auth.service';
import { Store } from '@ngrx/store';
import { State } from '../../store/store.interface';

import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { handle2FA, redirectToLogin } from '../guard.functions';
import { deleteUser } from '../../store/user/user.actions';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const appConfig = inject(AppConfiguration);
  const auth = inject(AuthService);
  const router = inject(Router);
  const store = inject(Store<State>);

  const loginRoute = appConfig.getValue('login.page');

  if (auth.isLoggedIn(true)) {
    return of(true).pipe(map(() => handle2FA(auth, router)));
  } else {
    return redirectToLogin(router, loginRoute, state.url, store, deleteUser({}));
  }
};
